import { UserRoleEnum } from '../types/user'

interface UserDisplayNameProps {
  email?: string
  name?: string
  phone?: string
}

export const userDisplayName = (user: UserDisplayNameProps | null | undefined): string => {
  if (!user) {
    return 'Unknown User'
  }
  const { email, name, phone } = user
  return name || email || phone || 'Unknown User'
}

// This function is used to check if the user is a Chaine Admin
export const isAdmin = (accessType: string, email: string) => {
  const isChaineAdmin =
    (accessType === 'Admin' || accessType === 'Owner') && email.includes('@chaineapp.com') ? true : false

  return isChaineAdmin
}

/**
 * Possible user roles
 */
export const roles = [
  { label: 'Carrier Sales Rep', value: UserRoleEnum.CarrierSalesRep },
  { label: 'Customer Sales Rep', value: UserRoleEnum.CustomerSalesRep },
  { label: 'Dispatcher', value: UserRoleEnum.Dispatcher },
  { label: 'Driver', value: UserRoleEnum.Driver },
  { label: 'Owner Operator', value: UserRoleEnum.OwnerOperator },
  { label: 'Shipper Sales Rep', value: UserRoleEnum.ShipperSalesRep }
]
